import { MultiSelectFilter } from '@library/components/filters';
import type { SelectOptions } from '@library/types/utils';

interface RankDrawerTeamsSelectProps {
  handleSelectTeam: (value: Array<string>) => void;
  selectedTeams: Array<string>;
  teamOptions: SelectOptions;
}

export const RankDrawerTeamsSelect = ({
  handleSelectTeam,
  selectedTeams,
  teamOptions
}: RankDrawerTeamsSelectProps) => (
  <MultiSelectFilter
    label="Teams"
    onChange={handleSelectTeam}
    options={teamOptions}
    size="medium"
    selectedValues={selectedTeams}
  />
);
